import { v4 as makeUuid } from 'uuid'
import { AxiosInstance } from 'axios'
import { AuthSubject, IUrlUtils } from 'v2/modules/lib'

export interface IAuthServiceArgs {
  httpClient: AxiosInstance
  urlUtils: IUrlUtils
}

export const makeAuthService = ({ httpClient }: IAuthServiceArgs) => {
  const getAvailableAuthPolicies = async (subjects?: AuthSubject[]): Promise<Array<Record<string, any>>> => {
    const res = await httpClient.get('/auth-service/me/auth-policies', {
      params: subjects ? { subject: subjects.join(',') } : undefined,
      headers: {
        'X-Request-ID': makeUuid()
      }
    })
    return res.data
  }

  return Object.freeze({
    getAvailableAuthPolicies
  })
}
